import {
  WSCard,
  WSInfoBox,
  WSList,
  WSPillProps
} from "@wingspanhq/fe-component-library";
import { InsuranceMonitor } from "@wingspanhq/wingspan-api-sdk";

import { InsuranceCoverageDataView } from "../../../../MyResources/components/InsuranceCoverageDataView";
import { useGoToMyResourceDetails } from "../../../../MyResources/paths";
import {
  RequirementContextType,
  RequirementTableItemData
} from "../../../types";

type Props = {
  requirement: RequirementTableItemData;
  insuranceMonitor: InsuranceMonitor;
  description: string;
  pill: WSPillProps;
  context: RequirementContextType;
  onDownloadClick?: () => void;
};

export const InsuranceCoverageDetails: React.FC<Props> = ({
  insuranceMonitor,
  description,
  pill,
  onDownloadClick,
  context
}) => {
  const goToView = useGoToMyResourceDetails();

  // the matched coverage rides along on the monitor — every monitor read
  // requests `expand[]=Coverage` (see `INSURANCE_MONITOR_EXPAND`)
  const { coverage } = insuranceMonitor;

  return (
    <WSList gap="L">
      <WSCard
        actions={{
          alignment: "fill",
          buttons:
            context === RequirementContextType.Payer
              ? [
                  {
                    label: "View policy",
                    kind: "Secondary",
                    onClick() {
                      goToView(insuranceMonitor.coverageId!);
                    }
                  }
                ]
              : onDownloadClick
                ? [
                    {
                      label: "View policy",
                      kind: "Secondary",
                      onClick: onDownloadClick
                    }
                  ]
                : []
        }}
        header={{
          label: "Policy information",
          value: {
            pill
          }
        }}
      >
        <WSList gap="XL" pb="L">
          <WSInfoBox>{description}</WSInfoBox>
          {coverage ? (
            <InsuranceCoverageDataView insuranceCoverage={coverage} />
          ) : null}
        </WSList>
      </WSCard>
    </WSList>
  );
};
